import { UniversalFilterConfig } from "../../components/Filters/ReportFilter";

export const inventoryInitialReportFilters: UniversalFilterConfig[] = [
  {
    name: "branchId",
    label: "Sucursal",
    type: "select",
    iconKey: "branch",
  },
  {
    name: "dateFrom",
    label: "Fecha Desde",
    type: "date",
    iconKey: "calendar",
  },
  {
    name: "dateTo",
    label: "Fecha Hasta",
    type: "date",
    iconKey: "calendar",
  },
];
